/**
 * 活动ID：CONFIG['data'].actId[typeId]  
   礼包ID：CONFIG['data'].rewardId[typeId][0]*/ 
// import md5 from 'js-md5'
import  md5  from 'md5'
import { get } from "./axios";
declare var CONFIG: Object;

// sdk登录
export const loginWithAccount = (username, password) => {
  let params = {
    userName: username,
    password: md5(password),
    version: CONFIG['data'].version
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].login, params)
}

// FB登录
export const loginWithFB = (token) => {
  let params = {
    clientId: CONFIG['data'].appId,
    access_token: token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].fb_login, params)
}

// kakao登录
export const loginWithKakao = (token) => {
  let params = {
    clientId: CONFIG['data'].appId,
    access_token: token,
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].kk_login, params)
}

//初始化区服列表
export const initZones = (msg) => {
  let params = {
    appId: CONFIG['data'].appId,
    token: msg.token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].zone, params)
}

// 获取角色
export const findRole = (msg) => {
  let zoneId = msg;
  let params = {
    appId: CONFIG['data'].appId,
    gameZoneId: zoneId,
    token: localStorage.token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].role, params)
}

// 获取所有活动历史记录
export const getAllHistory = () => {
  let params = {
    groupId: CONFIG['data'].groupId,
    token: localStorage.token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].CdKeys_all, params)
}

// 获取单个活动历史记录
export const getHistory = (typeId) => {

  let params = {
    groupId: CONFIG['data'].groupId,
    actId: CONFIG['data'].actId[typeId],
    token: localStorage.token,
    rewardId: CONFIG['data'].rewardId[typeId][0],
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].cdKeys, params)
}

// 获取活动信息
export const infoActivity = (typeId) => {
  let params = {
    groupId: CONFIG['data'].groupId,
    actId: CONFIG['data'][typeId],
    token: localStorage.token,
    rewardId: CONFIG['data'][typeId].rewardId[0],
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].info, params)
}

// 参加活动join
export const joinActivity = (typeId, index) => {
  let params = {
    groupId: CONFIG['data'].groupId,
    actId: CONFIG['data'].actId[typeId],
    token: localStorage.token,
    rewardId: CONFIG['data'].rewardId[typeId][index]
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].join, params)
}

// 许愿
export const wishActivity = (wish_word, goodsId) => {
  let params = {
    groupId: CONFIG['data'].groupId,
    token: localStorage.token,
    goodsId: goodsId,
    userInfo: JSON.stringify({
      "wish": wish_word
    })
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].makeWish, params)
}
//所有许愿记录
export const wishHistory = (length) => {

  let params = {
    actId: CONFIG['data'].actId.wish,
    groupId: CONFIG['data'].groupId,
    limit: length,
    token: localStorage.token,
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].desireList, params)
}
// 点击翻转卡牌
  //一键翻开index：-1；正常翻开index：0
export const joinFilp = (typeId,index) => {
  let params = {
    groupId: CONFIG['data'].groupId,
    actId: CONFIG['data'][typeId].id,
    token: localStorage.token,
    index: index
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].flip, params)  
}
// 卡牌活动信息
export const infoFlip = (typeId) => {
  let params = {
    groupId: CONFIG['data'].groupId,
    actId: CONFIG['data'][typeId].id,
    token: localStorage.token,
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].fflInfo, params)  
}
// 获取预约人数
export const reserveInfo = ()=>{
  let params = {
    groupId:CONFIG['data'].groupId,
    actId:CONFIG['data'].actId.reserve,
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].info, params)  
}
// 参与预约
export const reserveJoin = (userPhone)=>{
  let params = {
    groupId:CONFIG['data'].groupId,
    actId:CONFIG['data'].actId.reserve,
    phone: userPhone,
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].reserveJoin, params)  
}
// 預約轉盤
export const roteJoin = (fb)=>{
  let params = {
    groupId:CONFIG['data'].groupId,
    actId:CONFIG['data'].actId.rotate,
    token: localStorage.token,
    fbshare:fb
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].roteJoin, params)  
}
export const roteInfo = ()=>{
  let params = {
    groupId:CONFIG['data'].groupId,
    actId:CONFIG['data'].actId.rotate,
    token: localStorage.token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].roteInfo, params)  
}

//获取礼包记录
export const roteCdkeys = ()=>{
  let params = {
    groupId:CONFIG['data'].groupId,
    actId:CONFIG['data'].actId.rotate,
    token: localStorage.token
  }
  return get(CONFIG['BASE_URL'] + CONFIG['api'].roteCdkeys, params)  
}

